import React, {useState} from "react";

import API from "../Global/API";
import {useAuth} from "../Global/Auth";
import SpecialtyForm from "./SpecialtyActions/SpecialtyForm";
import DialogHeading from "../Components/Typography/DialogHeading";

import Menu from "@mui/material/Menu";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

/**
 * SpecialtyActions component.
 *
 * @returns {*}
 * @constructor
 */
const SpecialtyActions = (props) => {
    const {
        record,         // {Object} The employee record / context.
        doReload,       // {Function} Reloads the parent layout, if applicable.
    } = props;

    const [anchorEl, setAnchorEl] = useState(null);
    const [isEditing, setEditing] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [isConfirmingDelete, setConfirmDelete] = useState(false);
    const {hasPermissionTo, hasOneOfPermissions, hasAllPermissions} = useAuth();

    /**
     * Indicates whether an anchor target exists for the menu.
     *
     * @type {boolean}
     */
    const open = Boolean(anchorEl);


    /**
     * Fired whenever the menu button is clicked.
     *
     * @param event
     */
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };


    /**
     * Closes the menu popover.
     */
    const handleClose = () => {
        setAnchorEl(null);
    };


    /**
     * Reveals the employee edit form.
     */
    const handleSpecialtyEditOpen = () => {
        handleClose();
        setEditing(true);
    };


    /**
     * Hides the employee edit form.
     */
    const handleSpecialtyEditClose = () => {
        setEditing(false);
    };


    /**
     * Handles the employee record save.
     */
    const handleSpecialtySave = (record) => {
        handleSpecialtyEditClose();

        if (doReload) {
            doReload(record);
        }
    };


    /**
     * Reveals the delete confirmation.
     */
    const handleDeleteConfirmOpen = () => {
        setConfirmDelete(true);
    };


    /**
     * Hides the delete confirmation.
     */
    const handleDeleteConfirmClose = () => {
        setConfirmDelete(false);
    };


    /**
     * Processes the delete action.
     *
     * @returns {Promise<void>}
     */
    const doDelete = async () => {
        setLoading(true);

        const response = await API.put(`specialties/${record.id}`, {
            isDeleted: true
        });

        if(doReload){
            doReload(response);
        }

        setLoading(false);
        setConfirmDelete(false);
    };

    return (
        <div>
            {hasOneOfPermissions(['EDIT_LIBRARIES', 'DELETE_LIBRARIES']) && (
                <IconButton onClick={handleClick}>
                    <MoreHorizIcon/>
                </IconButton>
            )}

            <Menu
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
            >
                {hasPermissionTo('EDIT_LIBRARIES') && (
                    <MenuItem onClick={handleSpecialtyEditOpen}>Edit Specialty</MenuItem>
                )}

                {hasAllPermissions(['EDIT_LIBRARIES', 'DELETE_LIBRARIES']) && (
                    <Divider/>
                )}

                {hasPermissionTo('DELETE_LIBRARIES') && (
                    <MenuItem
                        onClick={handleDeleteConfirmOpen}
                        disabled={record.isDeleted}
                        className={'menu__error'}
                    >Delete Record</MenuItem>
                )}
            </Menu>

            {isEditing && (
                <SpecialtyForm
                    open={true}
                    record={record}
                    onSave={handleSpecialtySave}
                    onClose={handleSpecialtyEditClose}
                />
            )}

            {isConfirmingDelete && (
                <Dialog
                    open={true}
                    scroll={'body'}
                    onClose={handleDeleteConfirmClose}
                    maxWidth={'xs'}
                    fullWidth
                >
                    <DialogHeading
                        title={"Confirm Delete"}
                        noMargin
                    />
                    <DialogContent>
                        Are you sure that you'd like to delete this record?
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={doDelete}
                            children={'Delete'}
                            disabled={isLoading}
                        >
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </div>
    );
};

export default SpecialtyActions;